import React, {Component} from 'react';

const statusBackground = {
    已提交: '#c7f',
    进行中: '#c7f',
    已完成: '#87d166',
    未领取: '#f56c6c',
    '草稿': 'rgb(204, 204, 204)'
};

class NormalStatus extends Component {
    render() {
        let {text, record} = this.props;
        return <div style={{
            display: "flex",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            alignItems: "center"
        }}>
            <div style={{
                width: "8px",
                height: "8px",
                borderRadius: '50%',
                marginRight: '5px',
                background: statusBackground[text]
            }}></div>
            <div>{text}</div>

        </div>
    }
}

export default NormalStatus;
